module.exports = __webpack_public_path__ + "img/_0004_图层-6.16233e85.png";